import { render, staticRenderFns } from "./FullTextPopup.vue?vue&type=template&id=ddba99ca"
import script from "./FullTextPopup.vue?vue&type=script&lang=js"
export * from "./FullTextPopup.vue?vue&type=script&lang=js"
import style0 from "./FullTextPopup.vue?vue&type=style&index=0&id=ddba99ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports